import styled from 'styled-components'
import { COLORS } from '../../../../styles/colors'

export const StyledPresets = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
`
